import accountCookieHandler from 'components/navigation/Header/lib/accountCookieHandler';

document.addEventListener('DOMContentLoaded', () => {
  accountCookieHandler();
});
